import Swiper from 'swiper';
const BrandSlider = {

    _swiperBrandObj : '',

    init() {
        if ($('.jsBrands').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        this._swiperBrandObj = new Swiper($('.jsBrands')[0], {
            slidesPerView:1,
            spaceBetween:20,
            loop:true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: true,
              },
            pagination: {
                el: '.hotel__swiper-wrapper .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.hotel__swiper-wrapper .swiper-button-next',
                prevEl: '.hotel__swiper-wrapper .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                },
        });

        // $('.jsBrands').on('mouseenter', function(){
        //     console.log('stop autoplay');
        //     this._swiperBrandObj.stopAutoplay();
        //   }) ;
        //   $('.jsBrands').on('mouseleave', function(){
        //     console.log('start autoplay');
        //     this._swiperBrandObj.startAutoplay();
        //   });
    },
}
export default BrandSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_brands-slider.js